import React from "react";

const Consultants = () => {
    const consultants = [
        {
            name: "Mr. Jujhar Singh Bajwa",
            marn: "MARN: 0742209(Melbourne)",
            mia: "MIA: 2716",
            imgSrc: "./img/5.png" // Replace with actual image URL
        },
        {
            name: "Mr. Mandeep Singh",
            marn: "MARN: 2015849(Tarneit)",
            mia: "MIA: 23425",
            imgSrc: "./img/memb-2.jpeg" // Replace with actual image URL
        },
        {
            name: "Mr. Gurvinderjeet Singh Parmar",
            marn: "MARN: 1808842(Adelaide)",
            mia: "",
            imgSrc: "./img/1.png" // Replace with actual image URL
        },
        {
            name: "Mr. Mandeep Singh Chahal",
            marn: "MARN: 2418383(Brisbane)",
            mia: "",
            imgSrc: "./img/7.png" // Replace with actual image URL
        },
        {
            name: "Mr. Shamsher Kainth",
            marn: "MARN: 2117656(Melbourne)",
            mia: "",
            imgSrc: "./img/3.png" // Replace with actual image URL
        },
        {
            name: "Mr. Ravinder Singh",
            marn: " MARN: 1678111(Thomastown)",
            mia: "",
            imgSrc: "./img/2.png" // Replace with actual image URL
        },
        {
            name: "Mr. Mukesh Kumar Sharma",
            marn:"(Director & Marketing Specialist),Bajwa Immigration Pvt Ltd (Jalandhar) & Bajwa Immigration Services (Amritsar)",
            mia: "",
            imgSrc: "./img/8.png" // Replace with actual image URL
        },
        {
            name: "Mr. Harsh Yadav",
            marn: "MARN: 2117646(Sydney)",
            mia: "",
            imgSrc: "./img/6.png" // Replace with actual image URL
        },
        {
            name: "Mrs. Sandeep Kaur",
            marn: "MARN: 2418693(Geelong VIC)",
            mia: "MIA: 13473",
            imgSrc: "./img/10.png" // Replace with actual image URL
        },
        {
                name: "Mr. Gurjinder Singh ",
                marn: "MARN: 2518765(Perth)",
                mia: "",
                imgSrc: "./img/9.jpg" // Replace with actual image URL
            },
            {
                name: "Mr. Amarjit Singh Bajwa",
                marn: "MARN: 2418706(Dandenong)",
                mia: "",
                imgSrc: "./img/11.jpg" // Replace with actual image URL
            },{
                name: "Mr. Amit Kumar",
                marn: "(Jalandhar)",
                mia: "",
                imgSrc: "./img/12.jpg" // Replace with actual image URL
            },

        
    ];

    return (
        <div className="container text-center py-5">
            <h2 className="mb-4 text-primary">OUR CONSULTANTS</h2>
            <div className="row justify-content-center">
                {consultants.map((consultant, index) => (
                    <div key={index} className="col-md-4 mb-4">
                        <div className="card shadow p-3 rounded" style={{ height: "100%" }}>
                            <img
                                src={consultant.imgSrc}
                                alt={consultant.name}
                                className="rounded mb-3"
                                style={{ width: "100%", height: "auto" }}
                            />
                            <h5>{consultant.name}</h5>
                            <p> {consultant.marn}</p>
                            
                            {consultant.mia && <p>{consultant.mia}</p>}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Consultants;
